import React, { Component, Fragment } from 'react';
import MetaTags from "react-meta-tags";
import Breadcrumb from "../layouts/Breadcrumb";
import Header from '../layouts/Headerthree';
import Footer from '../layouts/Footerthree';
import Content from '../sections/Whyus/Content';

class Whyus extends Component {
    render() {
        return (
            <Fragment>
                <MetaTags>
                    <title>Onitir | Why Choose Us</title>
                    <meta
                        name="description"
                        content="#"
                    />
                </MetaTags>
                <Header />
                <Breadcrumb breadcrumb={{pagename:'Why Choose Us'}} />
                <Content/>
                <Footer />
            </Fragment>
        );
    }
}

export default Whyus;